import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

const Header = () => {
  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <center>
              <Row>
                <h1>
                  <font color="#FFFFFF"> INSPECCION DE VEHICULOS.</font>
                </h1>{" "}
              </Row>
            </center>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
